// Fallback shipping weight/dimensions for products nobody has weighed yet.
//
// Why this exists: the bulk upload wizard creates products from photos and
// never asked for weight or dimensions, so every bulk-created product landed
// with weight_oz NULL. The checkout rate quote falls back to 4oz for an
// unweighed item, which is roughly right for a single card and badly wrong for
// sealed product — a booster box quoted as a 4oz bubble mailer means the
// carrier bills the difference back to the shop after the label has already
// been sold at the wrong price.
//
// Category kind alone isn't enough for sealed: "Sealed Product" covers a 1oz
// booster pack and a 35oz booster box, a 35x difference. So sealed gets refined
// by product name, which the bulk wizard already has at insert time.
//
// These are starting points, not measurements. Anything actually put on a scale
// should be corrected on the product edit page, which overrides all of this.

const KIND_DEFAULTS = {
  single:    { weight_oz: 2,  length_in: 6,  width_in: 4,  height_in: 0.5 },
  sealed:    { weight_oz: 28, length_in: 12, width_in: 9,  height_in: 4 },
  accessory: { weight_oz: 8,  length_in: 9,  width_in: 6,  height_in: 3 },
  other:     { weight_oz: 6,  length_in: 9,  width_in: 6,  height_in: 2 },
};

// Ordered — first match wins, so the narrower patterns come first. "Booster
// box" must be tested before "booster" alone would catch a booster pack.
const SEALED_PATTERNS = [
  { test: /booster box/i,            weight_oz: 38, length_in: 15, width_in: 8, height_in: 5 },
  { test: /elite trainer box|\betb\b/i, weight_oz: 32, length_in: 15, width_in: 8, height_in: 4 },
  { test: /booster bundle|build ?& ?battle/i, weight_oz: 12, length_in: 12, width_in: 8, height_in: 3 },
  { test: /\btin\b|collection box|premium collection/i, weight_oz: 18, length_in: 10, width_in: 8, height_in: 3 },
  { test: /booster pack|blister|sleeved pack/i, weight_oz: 3, length_in: 7, width_in: 5, height_in: 0.75 },
];

export function shippingDefaultsFor(kind, name = '') {
  if (kind === 'sealed' && name) {
    const hit = SEALED_PATTERNS.find((p) => p.test.test(name));
    if (hit) {
      const { test, ...dims } = hit;
      return dims;
    }
  }
  return KIND_DEFAULTS[kind] || KIND_DEFAULTS.other;
}
